import { combineReducers } from "redux";
import ConstantsStrings from "../constants/ConstantsStrings";

const initialState = {
  userData: {},
  loginTimestamp: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case ConstantsStrings.SET_USER_DATA:
      return {
        ...state,
        userData: action.payload,
      };
    case ConstantsStrings.SET_LOGIN_TIMESTAMP:
      return {
        ...state,
        loginTimestamp: action.payload,
      };
    default:
      return state;
  }
};

const dialogInitialState = {
  isUsersDialogOpen: false,
};

const dialogReducer = (state = dialogInitialState, action) => {
  switch (action.type) {
    case ConstantsStrings.OPEN_USERS_DIALOG:
      return {
        ...state,
        isUsersDialogOpen: true,
      };
    case ConstantsStrings.CLOSE_USERS_DIALOG:
      return {
        ...state,
        isUsersDialogOpen: false,
      };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  user: userReducer,
  dialog: dialogReducer,
});

export default rootReducer;
